import { styles } from './template.scss';
import { FontSizes, FontWeights } from '../../../../../types/common/types';

export const templateSubmitToSandboxSamplesForm = document.createElement('template');

templateSubmitToSandboxSamplesForm.innerHTML = `
  <style>${styles}</style>
  <div class="wrapper">
    <gz-title id="title" fontSize='${FontSizes.HEADING_4}' fontWeight='${FontWeights.MEDIUM}'></gz-title>
    <gz-text id="description" fontSize='${FontSizes.PARAGRAPH_12}'></gz-text>
    <gz-form-field id="input-text-grid-form-field">
      <gz-input-text-grid id="input-grid" gz-form-input></gz-input-text-grid>
    </gz-form-field>
  </div>
`;

/**
 * Params:
 * label
 * placeholder
 * columnName
 * addItemText
 * Validator (optional)
 */
